import { render, staticRenderFns } from "./Sdann2Sdann5Chart.vue?vue&type=template&id=771a3fd3"
import script from "./Sdann2Sdann5Chart.vue?vue&type=script&lang=js"
export * from "./Sdann2Sdann5Chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports